import React, { forwardRef } from 'react';

import './_button-group.scss'
import './_button-group.dark-mode.scss'

import PropTypes from 'prop-types';

import { Flex } from '../../Layout';

const FiltersGroup = forwardRef(
  (props, ref) => (
    <Flex
      gap={8}
      wrap="wrap"
      ref={ref}
      {...props}
    >
      {props.children}
    </Flex>
  ),
)

FiltersGroup.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
}

export default FiltersGroup
